<template>
    <q-layout view="lHh Lpr lFf">
        <q-page-container>
            <q-page class="flex flex-center login-background-color">
                <form @submit.prevent="login">
                    <q-card
                        class="q-pa-md shadow-8 text-white bg-black"
                        bordered
                    >
                        <q-card-section class="text-center">
                            <img
                                src="@/assets/logo-white.png"
                                alt="Logo de GLTN"
                                width="300px"
                            />
                            <div class="text-grey-2 q-mt-md">
                                Por favor ingrese sus credenciales
                            </div>
                        </q-card-section>
                        <q-card-section v-if="statusMessage" class="q-pt-none">
                            <q-banner class="bg-orange-9 text-white" rounded>
                                {{ statusMessage }}
                            </q-banner>
                        </q-card-section>
                        <q-card-section>
                            <q-input
                                outlined
                                v-model="email"
                                label="Correo Electrónico"
                                color="white"
                                bg-color="grey-8"
                                label-color="grey-2"
                                dark
                                name="email"
                            ></q-input>
                            <q-input
                                outlined
                                class="q-mt-md"
                                v-model="password"
                                type="password"
                                label="Contraseña"
                                color="white"
                                bg-color="grey-8"
                                label-color="grey-2"
                                dark
                                name="password"
                            ></q-input>
                        </q-card-section>
                        <q-card-section>
                            <q-btn
                                style="border-radius: 8px"
                                color="dark"
                                rounded
                                size="md"
                                label="Ingresar"
                                no-caps
                                class="full-width"
                                type="submit"
                                :loading="loading"
                                :disable="loading"
                            ></q-btn>
                        </q-card-section>
                    </q-card>
                </form>
            </q-page>
        </q-page-container>
    </q-layout>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import AuthService from "@/services/AuthService.js";
import { useQuasar } from "quasar";
import { router, usePage } from "@inertiajs/vue3";
defineOptions({ layout: AuthLayout });

const $q = useQuasar();
const page = usePage();
const email = ref("");
const password = ref("");
const loading = ref(false);
const statusMessage = computed(() => page.props.status || "");

const getLoginErrorMessage = (error) => {
    const status = error?.status ?? error?.response?.status;
    const code = error?.code ?? error?.response?.code;
    const backendMessage = error?.data?.message ?? error?.response?.data?.message;

    if (code === "ERR_NETWORK" || !status) {
        return "No se pudo conectar al servidor. Verificá tu conexión e intentá nuevamente.";
    }

    if (status === 401 || status === 422) {
        return "Credenciales inválidas. Revisá correo y contraseña.";
    }

    if (status === 419) {
        return "La sesión expiró. Recargá la página e intentá de nuevo.";
    }

    if (status >= 500) {
        return "Error interno del servidor. Intentá nuevamente en unos minutos.";
    }

    return backendMessage || "Error de autenticación.";
};

const login = async () => {
    try {
        loading.value = true;
        await AuthService.login({
            email: email.value,
            password: password.value,
        });
        router.visit("/");
    } catch (error) {
        console.error("Login error:", error);
        $q.notify({
            type: "negative",
            message: getLoginErrorMessage(error),
        });
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    if (statusMessage.value) {
        $q.notify({
            type: "warning",
            message: statusMessage.value,
        });
    }
});
</script>

<style scoped>
.login-background-color {
    background: #23556f;
    background: radial-gradient(
        circle,
        rgba(35, 85, 111, 1) 0%,
        rgba(23, 39, 45, 1) 100%
    );
}
</style>
